// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('import.budgetimport', {
        url: '/import/budget',
        parent: 'main',
        templateUrl: 'main/import/budgetImport/budgetImport.tpl.html',
        controller: 'BudgetImportController as vm'
    });
}

// @ngInject
function BudgetImportController() {
    var vm = this;
}

angular.module('import.budgetimport', [
    ])
    .config(stateConfig)
    .controller('BudgetImportController', BudgetImportController);

